import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=7bb38a89&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"
import style0 from "./Tree.vue?vue&type=style&index=0&id=7bb38a89&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb38a89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bb38a89')) {
      api.createRecord('7bb38a89', component.options)
    } else {
      api.reload('7bb38a89', component.options)
    }
    module.hot.accept("./Tree.vue?vue&type=template&id=7bb38a89&scoped=true", function () {
      api.rerender('7bb38a89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/Tree.vue"
export default component.exports